module.exports = __webpack_public_path__ + "img/slide1.61dcc9a3.jpg";